export function formatProjectName(
  name: string,
  eventStartDate: number | string | null | undefined,
): string {
  if (!eventStartDate) return name;

  const year = new Date(eventStartDate).getFullYear();
  if (Number.isNaN(year)) return name;

  return `${name} (${year})`;
}
